import React, {useEffect} from 'react';
import ObjectDataHolder from "../Hooks/ObjectDataHolder";
import { findOutFormMode, getData, handleCurrentDateTime} from "./functions"
 import {useLocation, useParams} from "react-router-dom";
import RasaForm from "./RasaForm";
import {FormContext} from "./FormContext";
import Loader2 from "../Loader2";
import Loader from "../Loader";

const initialObject = {
  formMode: '',// add or edit
  formConfig: [],
  title: "در حال بار گزاری عنوان...",
  hidden: [],
  exceptionFields: [],
  nextBtn: "0",
  entity: "",
  filteredFormConfig: [// اینجوریم توجه میسم که آیا این فرم  متاثر از  سلکت آپشت یا رادیو عوض کردن بوده یا خیر
    // این کمک میکنه تا بعدا که میخوام ولیدیشن کنم  اگه چیزی هیدن بود و تحت تاثیر  سلکت عوض کردن نبود یا بود بتونم کنترل کنم
    // {
    // hasEffectedByHidden: undefined , true  // undefined mean  False, True Mean  it is effected By change select Option
    // }
  ],

  holder_id: "", //پیشوند هولدر گذاشتم  چون اینا از توی صفحه ای که جدول هست مقدار دهی میشه
  holder_urlId: "", // ممکنه این مورد از صفحه ی جدول نباشه ولی خب اینم پیشوند هولدر میزارم
  holder_primaryKey: "",
  holder_myLocation: "",
  mode: "ready", // if Mode is "sending"  Meaning that  disable Submit Button
  showBarcode: undefined,
  reload: 0

}

const Form = ({id, primaryKey}) => {

  const myLocation = useLocation()
  let urlId = useParams()["id"];
  const [myData, setMyData] = ObjectDataHolder(initialObject)
  const sendObject = {myData, setMyData, id, urlId, primaryKey, myLocation}


  useEffect(() => {
// در صورتی که  جای دیگه ای کلیک شد آی دی عوض شد صفحه عوض شد  باید این مقدار دهی اولیه بشه و خالی بشه



    const incomeData = {
      holder_id: id, holder_urlId: urlId, holder_primaryKey: primaryKey, holder_myLocation: myLocation,
    }

    getData(incomeData).then(result => {

      const formMode = findOutFormMode(result)
      setMyData({...initialObject, ...incomeData, ...result, formMode})

    })

  }, [id, primaryKey, myLocation, urlId])


  useEffect(() => {
    if (myData?.formMode === 'add') {
      // add current Time and Current Date to date and Time types
      const formConfig = handleCurrentDateTime({formConfig: myData?.formConfig})
      setMyData({formConfig})
    }


  }, [myData?.formMode])




  console.log(myData)
  try {
    if (Object.keys(myData.formConfig)?.length > 0) {
      return (<FormContext.Provider value={{myData, setMyData}}>
        <RasaForm/>
      </FormContext.Provider>);
    } else {
      return (<div className={'w-100 text-center'}>
        <Loader text={'در حال بارگزاری فرم...'}/>
      </div>);
    }

  } catch (error) {
    return <small>خطایی در بارگزاری اطلاعات رخ داده</small>
  }
};

export default React.memo(Form);
